import { SimpleList } from "@/components/list";

export const FAQS = [
  {
    title: "How does Cloud Security improve enterprise cybersecurity?",
    content: (
      <SimpleList
        points={[
          "Combines network security, Zero Trust policies, and AI-driven protection to minimize risks.",
          "Reduces attack surfaces by enforcing strict access controls.",
          "Blocks malware, ransomware, and unauthorized access to cloud environments.",
        ]}
      />
    ),
  },
  {
    title: "How does Cloud Firewall as a Service (FWaaS) protect cloud environments?",
    content: (
      <SimpleList
        points={[
          "Prevents unauthorized access and blocks malware, ransomware, and advanced threats.",
          "Reduces attack surfaces using network segmentation.",
        ]}
      />
    ),
  },
  {
    title: "How does Secure Web Gateway (SWG) enhance security?",
    content: (
      <SimpleList
        points={[
          "Blocks phishing, malicious websites, and browser-based malware.",
          "Monitors cloud application traffic to prevent data leaks.",
        ]}
      />
    ),
  },
  {
    title: "How does AI-powered threat detection enhance security?",
    content: (
      <SimpleList
        points={[
          "Analyzes cloud activity, user behavior, and security events in real time.",
          "Uses automated response mechanisms to prevent breaches.",
        ]}
      />
    ),
  },
  {
    title: "What compliance frameworks does OneMind’s Cloud Security & SASE support?",
    content: (
      <SimpleList
        points={["SOC 2, PCI-DSS, GDPR, ISO 27001, and NIST compliance monitoring."]}
      />
    ),
  },
  {
    title: "How does CASB integration protect cloud applications?",
    content: (
      <SimpleList
        points={["Prevents data loss, shadow IT risks, and unauthorized SaaS access."]}
      />
    ),
  },
  {
    title: "How does Zero Trust improve cloud security?",
    content: (
      <SimpleList
        points={[
          "Restricts access based on identity, device security, and risk posture.",
        ]}
      />
    ),
  },
  {
    title: "What are the benefits of integrating SD-WAN with SASE?",
    content: (
      <SimpleList
        points={["Enhances cloud performance and network security for remote users."]}
      />
    ),
  },
  {
    title:
      "Can OneMind’s Cloud Security solutions integrate with existing IT infrastructure?",
    content: (
      <SimpleList
        points={["Yes! Seamless integration with SIEM, IAM, and cloud platforms."]}
      />
    ),
  },
  {
    title: "How does risk-based authentication improve security?",
    content: (
      <SimpleList
        points={[
          "Analyzes login patterns and device activity to detect unauthorized access.",
          "Applies adaptive security controls based on risk level.",
        ]}
      />
    ),
  },
];
